import React from 'react'
import logo from '../../assets/image/logo.png'
import Image from 'next/image'
import { useSelector } from 'react-redux'
import { authSelector } from '../features/selectors/authSelector'
import Link from 'next/link'
import { usePathname } from 'next/navigation'

const Sidebars = ({ isSidebarOpen, setIsSidebarOpen }) => {
  const { user } = useSelector(authSelector);
  const pathname = usePathname();

  console.log("user", user)
  return (

    <div className={`${isSidebarOpen ? '!w-64' : '!w-20'} !bg-slate-900 !text-white !transition-all !duration-300 !flex !flex-col !shadow-2xl !z-50`}>
      <div className="!h-20 !flex !items-center !justify-center !border-b !border-slate-700">
        {isSidebarOpen ? (
          <h1 className="!text-2xl !font-bold !bg-gradient-to-r !from-blue-400 !to-emerald-400 !bg-clip-text !text-transparent">
            {/* <Image
              src={logo}
              alt="My Photo"
              width={50} // required
              height={30} // required
            /> */}
            Travov Admin
          </h1>
        ) : (
          <i className="pi pi-compass !text-2xl !text-blue-400"></i>
        )}
      </div>

      <nav className="!flex-1 !py-6">
        <ul className="!space-y-2">
          {[
            { label: 'Dashboard', icon: 'pi pi-th-large', href: '/' },
            { label: 'Users', icon: 'pi pi-user', href: '/users' },
            { label: 'Flights', icon: 'pi pi-send', href: '/flights' },
            { label: 'Hotels', icon: 'pi pi-building', href: '/hotels' },
            { label: 'Transactions', icon: 'pi pi-credit-card', href: '/transactions' },
            { label: 'Refunds', icon: 'pi pi-undo', href: '/refunds' },
            { label: 'Wallet Logs', icon: 'pi pi-wallet', href: '/wallet' },
             { label: 'Amadeus Logs', icon: 'pi pi-table', href: '/dev/logs' },
            { label: 'Support', icon: 'pi pi-comments', href: '/support' },
            // { label: 'Bookings', icon: 'pi pi-check-square' },
            // { label: 'Analytics', icon: 'pi pi-chart-bar' },
            { label: 'Platform Fees', icon: 'pi pi-dollar', href: '/platform-fees' },
            { label: 'Settings', icon: 'pi pi-cog', href: '/settings' },
          ].map((item, index) => {
            const isActive = pathname === item.href;
            return (
              <li key={index}>
                <Link href={item.href} className={`!flex !items-center !px-6 !py-3 !cursor-pointer !transition-colors ${isActive ? '!bg-slate-800 !border-l-4 !border-blue-500 !text-blue-400' : '!text-gray-400 hover:!text-white hover:!bg-slate-800'}`}>
                  <i className={`${item.icon} !text-lg !w-6`}></i>
                  {isSidebarOpen && <span className="!ml-4 !font-medium">{item.label}</span>}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>

      <div className="!p-4 !border-t !border-slate-700">
        <div className="!flex !items-center !gap-3">
          <div className="!w-10 !h-10 !rounded-full !bg-blue-500 !flex !items-center !justify-center !text-white !font-bold !overflow-hidden">
            {user?.profile_picture || user?.profile ? (
              <img 
                src={user.profile_picture || user.profile} 
                alt="Profile" 
                className="!w-full !h-full !object-cover"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = `<span class="!text-white">${user?.name?.charAt(0) || 'U'}</span>`;
                }}
              />
            ) : (
              <span className="!text-white">{user?.name?.charAt(0) || 'U'}</span>
            )}
          </div>
          {isSidebarOpen && (
            <div>
              <p className="!text-sm !font-semibold">{user?.name}</p>
              {/* <p className="!text-xs !text-gray-400">View Profile</p> */}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Sidebars
